import './social-network-info.ajscss';

import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './social-network-info.template.html';

const MODULE_NAME = 'contactSocialNetworkInfo';

class SocialNetworkInfoCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  public extraInfo: any;
  public screenName: string;
  public type: string;

  constructor(public readonly socialNetworkFrameService: ISocialNetworkFrameService) {}

  $onInit(): void {
    if (!this.responseId) {
      return;
    }
    const snModel = this.socialNetworkFrameService.getSocialNetworkByResponseId(this.responseId);
    if (!!snModel) {
      this.type = snModel.tab.getType;
      this.screenName = snModel.tab.socialNetworkName;
    }
  }
}

export class SocialNetworkInfo implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = <{ [binging: string]: string }>{
    responseId: '<',
  };
  controller = ['socialNetworkFrameService', SocialNetworkInfoCtrl];
}

export default MODULE_NAME;
